export const NavigationItems = [
    {
        title: 'Dashboard',
        tags: 'Dashboard',
        icon: 'fal fa-chart-line',
        routerLink: '/dashboard',
    },
    {
        title: 'Modules',
        tags: 'modules',
        icon: 'fas fa-th',
        routerLink: '/modules',
        items: [
            {
                title: 'Checks Management',
                tags: 'checks management',
                routerLink: '/modules/checksManagement'
            }
        ]
    },
    {
        title: 'Calendar',
        tags: 'calendar',
        icon: 'fal fa-calendar',
        routerLink: '/calendar',
    },
    {
        title: 'Archive',
        tags: 'archive',
        icon: 'fal fa-file-archive',
        routerLink: '/archive',
    },
    {
        title: 'Configurations',
        tags: 'configurations',
        icon: 'fas fa-sliders-h',
        routerLink: '/config'
    },
    {
        title: 'Help',
        tags: 'help',
        icon: 'fal fa-question-circle',
        routerLink: '/help',
    }

];
